import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import About from './About';
import Software from './Software';
import Medicina from './Medicina';
import TuIdea from './TuIdea';
import ServicioTecnico from './ServicioTecnico';
import WebDesing from './WebDesing';
import Contacto from './Contacto';
import PdfEditorPage from './PdfEditorPage';
import PrivacyPolicy from './PrivacyPolicy';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/about" element={<About />} />
        <Route path="/software" element={<Software />} />
        <Route path="/medicina" element={<Medicina />} />
        <Route path="/tu-idea" element={<TuIdea />} />
        <Route path='/web-desing' element={<WebDesing />} />
        <Route path="/servicio-tecnico" element={<ServicioTecnico />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/pdf-editor" element={<PdfEditorPage />} />
        <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
      </Routes>
    </HashRouter>
  </React.StrictMode>
);